import React from 'react';
import imgMucTieu from '../../../images/muctieu.png';
import imgMoHinh from '../../../images/mohinhkinhdoan.png';
import imgBaoMat from '../../../images/kientruchethong_baomat.png';
import IntroduceBusinessActivities from './IntroduceBusinessActivities';
import IntroduceSectionTitle from './IntroduceSectionTitle';
import StrategicObjectives from './diagrams/StrategicObjectives';
import BusinessModelTabs from './diagrams/BusinessModelTabs';
import ArchitectureDiagram from './diagrams/ArchitectureDiagram';
import i18n from '../../../language/i18n';
import { normalizeLang } from '../../../utils/localeDataLoader';

function IntroducrOriented() {
  const currentLang = normalizeLang(i18n.language);

  return (
    <div className="introduce-oriented">
      <div className="introduce__content-diagram introduce-oriented__visual">
        <StrategicObjectives />
      </div>

      <span className="introduce-oriented__divider" aria-hidden="true" />

      <div className="introduce__content-diagram introduce-oriented__visual">
        <BusinessModelTabs />
      </div>

      <IntroduceBusinessActivities className="introduce-oriented__activities" />

      <div className="introduce-oriented__security" style={{ width: '100%', marginTop: '36px' }}>
        <IntroduceSectionTitle>
          {currentLang === 'vi'
            ? 'CHÍNH SÁCH BẢO MẬT VÀ AN TOÀN THÔNG TIN'
            : 'SECURITY POLICY AND INFORMATION SAFETY'}
        </IntroduceSectionTitle>
        <div 
          className="introduce__content-diagram introduce-oriented__visual" 
          style={{ 
            marginTop: '24px',
            width: '100%',
            margin: '24px auto 0 auto',
            padding: '12px'
          }}
        >
          <ArchitectureDiagram />
        </div>
      </div>
    </div>
  );
}

export default IntroducrOriented;
